import { motion } from "framer-motion";
import { Card, CardContent } from "../../../components/tailwind/card";

export const StatCard = ({ stat, delay = 0 }) => {
    return (
        <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: stat.disabled ? 0.5 : 1, y: 0 }}
            transition={{ delay }}
            className={stat.disabled ? "pointer-events-none" : ""}
        >
            <Card className="h-full border-gray-200 dark:border-slate-800 bg-white dark:bg-slate-900 wa-card-hover">
                <CardContent className="p-5 sm:p-6">
                    <div className="flex items-start justify-between gap-3">
                        <div className={`p-2.5 rounded-xl ${stat.color}`}>
                            <stat.icon className="h-5 w-5" />
                        </div>
                        <span className="text-xs font-medium text-[#0F6E56] dark:text-emerald-400 bg-emerald-50 dark:bg-emerald-950/40 px-2 py-1 rounded-full shrink-0">
                            {stat.change}
                        </span>
                    </div>
                    <div className="mt-4">
                        <p className="text-2xl font-bold text-gray-900 dark:text-white tabular-nums">{stat.value}</p>
                        <p className="text-sm text-gray-500 dark:text-gray-400 mt-1">{stat.label}</p>
                    </div>
                </CardContent>
            </Card>
        </motion.div>
    );
};
